import PropTypes from 'prop-types';

export const ProductsDefaultProps = {
  addToCartOptions: null,
  className: null,
  disabled: false,
  isLoading: false,
  localOptions: [],
  productType: null,
  products: [],
  sortables: {},
};

export const ProductsPropTypes = {
  addToCartOptions: PropTypes.shape({}), // Defined in /abstract/Product/Product
  className: PropTypes.string,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  localOptions: PropTypes.arrayOf(PropTypes.shape({})),
  productType: PropTypes.string,
  products: PropTypes.arrayOf(PropTypes.shape({})),
  sortables: PropTypes.oneOfType([
    PropTypes.shape({
      [PropTypes.string]: PropTypes.shape({
        code: PropTypes.string,
        displayable: PropTypes.bool,
        filterable: PropTypes.bool,
        label: PropTypes.string,
        order: PropTypes.number,
        searchable: PropTypes.bool,
        sortable: PropTypes.bool,
        unit: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      }),
    }),
    PropTypes.arrayOf(PropTypes.shape({})),
  ]),
};
